// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"1095":"lab-journey","2879":"lab-composer","6796":"lab","9142":"lab-palette"}[chunkId] || chunkId) + "." + {"1095":"975287d7","2879":"6644c344","5655":"048dfa69","6796":"aae0611e","7529":"622c4e4e","9142":"6644c344"}[chunkId] + ".chunk.css";
};